import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { IFilterPagingParams, IUsersApiCall } from "utils/api.interfaces";
import { filterparams } from "utils/common";

import axiosinterceptor from "../utils/api.interceptor";

const fetchUsers = (params: IFilterPagingParams): Promise<IUsersApiCall> => {
  return axiosinterceptor
    .get(`/v1/Users`, {
      params: filterparams(params),
    })
    .then<IUsersApiCall>((res) => res.data);
};
export default function useUsers(
  params: IFilterPagingParams,
  options?: Omit<
    UseQueryOptions<
      IUsersApiCall,
      Error,
      IUsersApiCall,
      ["users", IFilterPagingParams]
    >,
    "queryKey" | "queryFn"
  >
) {
  const querySearch = useQuery({
    queryKey: ["users", params],
    queryFn: () => fetchUsers(params),
    enabled: !!params,
    ...options,
  });

  return querySearch;
}
